const filters = {
  all: 'all',
  active: 'active',
  done: 'done',
}

export { filters }
